/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Transition } from 'react-transition-group';
import { useDispatch, useSelector } from 'react-redux';
import { ExportToCsv } from 'export-to-csv';
import moment from 'utils/moment';
import SectionHeader from '../../../../components/sectionHeader';
import Table from '../../../../components/Table/Table';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import styles from './logs.module.scss';
import Button from '../../../../components/button';
import Filter from './Filter';
import { changeCurrentPage } from '../../../../general_redux/actions';
import { deletespecificAdpLog, fetchAdpLogs, ADP_Re_Print, getAdpDefaultFields, fetch_Permit_Logs_Excel_Export } from '../../redux/action';
import Paginator from '../../../../components/paginator/paginator';
import Loading from '../../../../components/loading';
import Summary from '../../../../components/DataSummary/Summary';
import Search from '../../../../components/search/Search';
import Forbidden from '../../../Forbidden';
import FilterForm from '../../components/filterForm/FilterForm';
import { getSelectedTableKeys, getStorageValue, handleLocalStorageColumns } from '../../components/editColumns';

const Logs = (props) => {
  const dispatch = useDispatch();
  const staticColumns = [
    {
      id: 'created_at',
      title: 'Date',
      selected: true,
      dataKey: 'created_at'
    },
    {
      id: 'application_type',
      title: 'Application Type',
      selected: true,
      dataKey: 'application_type'
    },
    {
      id: 'first_name',
      title: "Applicant's First Name",
      selected: true,
      dataKey: 'first_name'
    },
    {
      id: 'last_name',
      title: "Applicant's Last Name",
      selected: true,
      dataKey: 'last_name'
    },
    {
      id: 'badge_no',
      title: 'Permit Number',
      selected: false,
      dataKey: 'badge_no'
    },
    {
      id: 'renewal_date',
      title: 'Renewal Date',
      selected: true,
      dataKey: 'renewal_date'
    },
    {
      id: 'status',
      title: 'Status',
      selected: true,
      dataKey: 'status'
    }
  ];
  const [page, setPage] = useState(1);
  const [isExportRequested, setIsExportRequested] = useState(false);
  const [tableKeys, setTableKeys] = useState([]);
  const [state, setState] = useState({
    selectedFilters: [],
    filterPopup: false,
    actionPopup: false
  });
    const [sortKey, setSortKey] = useState('');
  const [filterCategories, setfilterCategories] = useState([]);
  const [filterObject, setFilterObject] = useState({});
  const [filterStatus, setFilterStatus] = useState();
  const [filterCategory, setFilterCategory] = useState([]);
  const [searchQuery, handleSearchQuery] = useState();
  const [allColumns, setAllColumns] = useState(staticColumns);
  const profile = useSelector(states => states.auth.profile);
  const filterOptions = useSelector(states => states?.permitManagement?.Adp_filteroptions);
  const logs = useSelector(states => states?.permitManagement?.Adp_logs);
  const enable_initial_review = useSelector(states => states?.permitManagement?.enable_initial_review);
  const scheduleEnable = useSelector(states => states?.permitManagement?.scheduleEnable);
  const summary = useSelector(states => states?.permitManagement?.Adp_summary);
  const logsCount = useSelector(states => states?.permitManagement?.totalLogsCount);
  const deleteStatus = useSelector(states => states?.permitManagement?.deletionStatus);
  const reprintLoader = useSelector(states => states?.permitManagement?.adpRePrintStatus);
  const settings = useSelector(states => states?.permitManagement?.adpDefaultFields);
  const defaultFields = useSelector(states => states?.permitManagement?.AdpDSchema);
  const customFields = useSelector(states => states?.permitManagement?.AdpCSchema);
  const getSchemaStatus = useSelector(states => states?.permitManagement?.adpGetSchemaStatus);
  const nomenclature = profile?.permit_management || {};
  const exportToLogsData= useSelector(states => states?.permitManagement?.excelData);
  const excleLoaderAction= useSelector(states => states?.permitManagement?.excleLoader);

  useEffect(() => {
    if (defaultFields && customFields) {
      const allFilteredFields =[...defaultFields, ...customFields].filter(
        field => !['signature', 'header', 'attachments'].includes(field.type)
        && !['first_name', 'last_name'].includes(field.id) && !field.isDisabled
      );
      setAllColumns([...staticColumns, ...allFilteredFields].map(
        each => ({ ...each, title: each.title, dataKey: each.id, id: each.id })
      ));
    }
  }, [defaultFields, customFields]);

  useEffect(() => {
    dispatch(getAdpDefaultFields());
    dispatch(changeCurrentPage(profile?.permit_management?.driver_permit || 'ADP'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!allColumns?.length) {
      return;
    }

    const savedColumns = getStorageValue('AdpColumns');
    const savedTableKeys = getStorageValue('AdptableKeys');
    const newColumns = handleLocalStorageColumns(allColumns, savedColumns, savedTableKeys);
    const data = getSelectedTableKeys(newColumns);

    setTableKeys(data);
    localStorage.setItem('AdpColumns', JSON.stringify(newColumns));
  }, [allColumns]);


  useEffect(() => {
    let filters = filterOptions;
    if (filterOptions) {
      const data = [
        {
          id: 1,
          name: 'Status',
          permissions: [{ id: '2', title: 'Pending Approval' }, { id: '3', title: settings?.badge_status?.[3] || 'Approved' },
            { id: '8', title: settings?.badge_status?.[8] || 'Suspended' },
            { id: '9', title: settings?.badge_status?.[9] || 'Revoked' },
            { id: '4', title: 'Rejected' },
            { id: '5', title: 'Expired' },
            { id: '7', title: 'Cancelled' },
            { id: '14', title: 'Draft' },
            { id: '15', title: 'Application Withheld' },
            { id: '25', title: 'Expiring in 30 days' },
            { id: '16', title: 'Expiring in 60 days' },
            { id: '17', title: 'Expiring in 90 days' },
            { id: '1', title: 'Pending Applicant Details' },
            { id: '0', title: 'Training Pending' },
            { id: '26', title: 'Re Print Request' }]
        },
        {
          id: 2,
          name: `${nomenclature?.driver_permit || 'ADP'} Category`,
          permissions: [...filters?.category_of_adp?.map(ele => ({ id: ele, title: ele }))]
        }
      ];
      if (enable_initial_review) {
        let newStatus = data[0]?.permissions;
        newStatus.unshift({ id: '6', title: 'Pending Review' });
        data[0].permissions = newStatus;
      }
      if (scheduleEnable) {
        data[0].permissions.push({ id: '11', title: 'Pending Schedule' });
      }
      setfilterCategories(data);
    } else {
      setfilterCategories([
        {
          id: 1,
          name: 'Status',
          permissions: []
        }
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions, enable_initial_review]);
  useEffect(() => {
    if (isExportRequested && exportToLogsData?.length > 0 && excleLoaderAction?.success) {
      exportToExcel();
      setIsExportRequested(false);
    }
  }, [exportToLogsData, isExportRequested]);
  useEffect(() => {
    dispatch(fetchAdpLogs(page, sortKey, filterStatus, undefined, filterCategory));
  }, [dispatch, page, sortKey]);

  const changePage = (pageNo) => {
    setPage(pageNo);
  };
  const handelFilter = (data) => {
    const status = [];
    let category_of_adp = data?.[`${nomenclature?.driver_permit || 'ADP'} Category`]
          ? data?.[`${nomenclature?.driver_permit || 'ADP'} Category`].join()
          : false;
    if (data.Status) {
      filterCategories[0].permissions.forEach((ele) => {
        data.Status.forEach((el) => {
          if (ele.title === el && enable_initial_review && el === 'Pending Approval') {
            status.push('6');
          } else if (ele.title === el && enable_initial_review && el === 'Pending Review') {
            status.push('2');
          } else if (ele.title === el) {
            status.push(ele.id);
          }
        });
      });
    }
    setFilterStatus(status);
    setFilterCategory(category_of_adp);
    dispatch(fetchAdpLogs(1, sortKey, status, undefined, category_of_adp));
    const filters = {
      category_of_adp: category_of_adp?.length === 0 ? false : category_of_adp
    };
    let filter_Object = {};

    if (category_of_adp) {
      let element = '';
      const key = `${nomenclature?.driver_permit || 'ADP'} Category`;
      if (Array.isArray(category_of_adp)) {
        element = category_of_adp;
      } else {
        element = category_of_adp?.includes(',') ? category_of_adp?.split(',') : [category_of_adp];
      }
      filter_Object = { ...filter_Object, [key]: element };
    }

    if (status?.length !== 0 && status !== false) {
      let element = '';
      if (Array.isArray(status)) {
        element = status;
      } else {
        element = status?.includes(',') ? status?.split(',') : [status];
      }
      filter_Object = { ...filter_Object, 'Status': element };
    }

    localStorage.setItem('ADPFilters', JSON.stringify(filters));
    if (Object.keys(filter_Object).length === 0) {
      setFilterObject(filter_Object);
    } else {
      setFilterObject(data);
    }
  };

  const handelDelete = (id) => {
    dispatch(deletespecificAdpLog(id));
  };
  const handleStatusFilter = (value) => {
    handelFilter({ Status: [value] });
    setState({ ...state, selectedFilters: [value] });
  };

  const handelReprint = (id) => {
    dispatch(ADP_Re_Print(id));
  };

  const columnData = (cols) => {
    const selectedTableKeys = cols
      ?.filter(column => column.selected === true)
      ?.map(column => [column.dataKey, column.title]) || [];
    const newColumns = handleLocalStorageColumns(allColumns, cols, selectedTableKeys);
    const data = getSelectedTableKeys(newColumns);
    setTableKeys(data);
    localStorage.setItem('AdpColumns', JSON.stringify(newColumns));
    localStorage.setItem('AdptableKeys', JSON.stringify(data));
  };

  const onSubmitSearch = (value) => {
    handleSearchQuery(value);
    dispatch(fetchAdpLogs(page, sortKey, filterStatus, value, filterCategory));
  };

  const getStatus = (ele) => {
    if (Number(ele) === 2 && enable_initial_review) {
      return 'Pending Review';
    }
    if ((Number(ele) === 6 && enable_initial_review)
        || (Number(ele) === 2 && !enable_initial_review)) {
      return 'Pending Approval';
    }
    if (ele === 0) {
      return 'Training Pending';
    } if (ele === 1) {
      return 'Pending Applicant Details';
    } if ((ele === 2 || ele === 6) && enable_initial_review) {
      return 'Pending Approval';
    } if (ele === 3) {
      return (settings?.badge_status?.[3] || 'Approved');
    } if (ele === 4) {
      return 'Rejected';
    } if (ele === 7) {
      return 'Cancelled';
    } if (ele === 5) {
      return 'Expired';
    } if (Number(ele) === 25) {
      return 'Expiring in 30 days';
    } if (Number(ele) === 16) {
      return 'Reschedule Test';
    } if (Number(ele) === 17) {
      return 'Expiring in 90 days';
    } if (Number(ele) === 18) {
      return 'Expiring in 180 days';
    } if (Number(ele) === 19) {
      return 'Expiring in 365 days';
    } if (Number(ele) === 26) {
      return 'Re Print Request';
    } if (Number(ele) === 8) {
      return (settings?.badge_status?.[8] || 'Suspended');
    } if (Number(ele) === 11) {
      return 'Pending Schedule';
    } if (Number(ele) === 9) {
      return (settings?.badge_status?.[9] || 'Revoked');
    } if (Number(ele) === 10) {
      return 'Payment Pending';
    } if (Number(ele) === 14) {
      return 'Draft';
    } if (Number(ele) === 15) {
      return 'Application Withheld';
    } return null;
  };
const finalData = (info, columnsArray) => info?.map((e) => {
    const obj = {};
    columnsArray.forEach((col) => {
      let value = e[col?.dataKey];
        if (col.id?.includes('custom-')) {
          value = e.response[col?.dataKey] || '';
        } else if (
        col?.dataKey.includes('created_at') || col?.dataKey.includes('payment_date')
        || col?.dataKey.includes('renewal_date') || col?.dataKey.includes('date')
        || col?.dataKey.includes('dob') || col?.dataKey.includes('training_completed_at')
      ) {
        value = value ? moment(value).format(localStorage?.getItem('dateFormat') || 'MM/DD/YYYY') : '';
      } else if (col?.dataKey?.includes('status')) {
        value = getStatus(Number(value));
      } else if (col?.dataKey==='activated_by') {
        value= e?.re_activated_by || '';
      }

      obj[col?.title] = value === null ? '' : value;
    });

    obj['Total Payment'] = e.total_amount === null ? '' : `${profile?.portal_airport?.airport_settings?.currency}${e.total_amount}`;

    return obj;
  });

const fetchExcle = async () => {
  setIsExportRequested(true);
  let status = [];
  let adpCategoryList = [];
  filterCategories[0].permissions.forEach((ele) => {
    if (filterObject?.Status?.length > 0) {
      filterObject.Status.forEach((el) => {
        if (ele.title === el && enable_initial_review && el === 'Pending Approval') {
          status.push('6');
        } else if (ele.title === el && enable_initial_review && el === 'Pending Review') {
          status.push('2');
        } else if (ele.title === el) {
          status.push(ele.id);
        }
      });
    }
  });
  filterCategories[1].permissions.forEach((ele) => {
    if (filterObject?.[`${nomenclature?.driver_permit || 'ADP'} Category`]?.length > 0) {
      filterObject[`${nomenclature?.driver_permit || 'ADP'} Category`].forEach((el) => {
        if (ele.title === el) {
          adpCategoryList.push(el);
        }
      });
    }
  });

  dispatch(fetch_Permit_Logs_Excel_Export(undefined, searchQuery, status, adpCategoryList));
};

  const handleActionPopup = () => {
    setState({ ...state, actionPopup: !state.actionPopup });
  };
  const exportToExcel = () => {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: false,
      showTitle: false,
      title: 'Adp Data',
      useTextFile: false,
      filename: `${profile?.portal_airport?.code}_Adp-Data`,
      useBom: true,
      useKeysAsHeaders: true
    };
    const csvExporter = new ExportToCsv(options);
    if (exportToLogsData) {
      if (exportToLogsData.length!==0) {
        csvExporter.generateCsv(finalData(exportToLogsData, allColumns));
    }
    handleActionPopup();
  }
  };

  const handleFilterDropdown = () => {
    setState({ ...state, filterPopup: !state.filterPopup });
  };

  const slideStyles = {
    entered: { transform: 'translate3d(0px,0px)' }
  };

  const handelUpdateFilters = (filterValues, filter_object) => {
    handelFilter(filter_object);
    setState({ ...state, selectedFilters: filterValues, filterPopup: !state.filterPopup });
  };

  const handleRemoveFilterFunction = (value) => {
    setState({ ...state, selectedFilters: state.selectedFilters.filter(ele => ele !== value) });
    handleRemoveFilter(value);
  };

  const handleRemoveFilter = (value) => {
    let result = {};
    result = Object.entries(filterObject).reduce((acc, [key, arr]) => {
      acc[key] = arr.includes(value)
        ? arr.filter(ele => ele !== value)
        : arr;
      return acc;
    }, {});

    let category_of_adp = result?.[`${nomenclature?.driver_permit || 'ADP'} Category`]?.length !== 0
      ? result?.[`${nomenclature?.driver_permit || 'ADP'} Category`]
      : false;
    let status = result?.Status?.length !== 0 ? [] : false;
    if (Array.isArray(result?.Status)) {
      filterCategories[0].permissions.forEach((ele) => {
        result.Status.forEach((el) => {
          if (ele.title === el && enable_initial_review && el === 'Pending Review') {
            status.push('2');
          } else if (ele.title === el && enable_initial_review && el === 'Pending Approval') {
            status.push('6');
          } else if (ele.title === el) {
            status.push(ele.id);
          }
        });
      });
    }
    let flag = false;
    Object.keys(result).forEach((ele) => {
      if (flag === false) {
        if (result[ele].length === 0) {
          flag = false;
        } else { flag = true; }
      }
    });

    if (!flag) {
      localStorage.setItem('adp_page', 1);
      dispatch(fetchAdpLogs(1, sortKey, undefined, undefined, undefined));
      setFilterObject({ ...filterObject, Status: [], 'Application Type': [], 'License Type': [], Company: [] });
      const filters = {
        status: false,
        category_of_adp: category_of_adp?.length === 0 ? false : category_of_adp };
      localStorage.setItem('ADPFilters', JSON.stringify(filters));
    } else {
      localStorage.setItem('adp_page', 1);
      dispatch(fetchAdpLogs(1, sortKey,
        status.length === 0 ? false : status, undefined, category_of_adp));
      const filters = {
        category_of_adp: category_of_adp?.length === 0 ? false : category_of_adp
      };
      localStorage.setItem('ADPFilters', JSON.stringify(filters));
      setFilterObject(result);
    }
  };

  const tags = [
    ['Pending Review', 'pending_approval', 'rgb(254,247,229)', '#3c62a8'],
    ['Pending Approval', 'reviewed', 'rgb(254,247,229)', 'rgb(247,186,96)'],
    ['Pending Approval', 'pending_approval', 'rgb(254,247,229)', 'rgb(247,186,96)'],
    [settings?.badge_status?.[3] || 'Approved', 'approved', 'rgb(239,250,227)', 'rgb(113,215,88)'],
    [settings?.badge_status?.[8] || 'Suspended', 'suspended', 'rgb(128, 128, 128)', 'rgb(128, 128, 128)'],
    [settings?.badge_status?.[9] || 'Revoked', 'revoked', '#404040', '#404040'],
    ['Rejected', 'rejected', 'rgb(255, 87, 51 )', 'rgb(255, 87, 51 )'],
    ['Expired', 'expired', 'rgb(128, 128, 128)', 'rgb(128, 128, 128)'],
    ['Cancelled', 'cancelled', '#404040', '#404040'],
    ['Expiring in 30 days', 'expiring_in_thirty_days', 'rgb(255, 87, 51 )', 'rgb(255, 87, 51 )'],
    ['Re Print Request', 'reprint', 'rgb(254,247,229)', 'rgb(247,186,96)']
  ];

  const handleTags = (usedTags) => {
    let newTags = usedTags;
    if (enable_initial_review) {
      if (newTags[2][1] === 'pending_approval') {
        newTags.splice(2, 1);
      }
    } else if (!enable_initial_review) {
      if (newTags[0][1] === 'pending_approval' && newTags[1][1] === 'reviewed') {
        newTags.splice(0, 2);
      }
    }
    if (!scheduleEnable) {
      newTags =newTags.filter(e => e[1]!== 'pending_schedule');
    }
    return newTags;
  };
 const handleSort = (newSort) => {
    setSortKey(newSort);
  };
  return <>
    <Loading loadingStatus={getSchemaStatus?.loading || deleteStatus?.loading || reprintLoader?.loading || excleLoaderAction?.loading}
    />
    <SectionHeader icon={PERMITMODULE} translationID=" " defaultTitle={profile?.permit_management?.driver_permit || 'ADP'} centered {...props}>
      <div className={styles.detailHeader} />
      <Search onSubmit={e => onSubmitSearch(e)} />
      {profile?.permissions?.driver_permit?.includes('add_driverpermit') && (
      <Button
        action="primary"
        onClick={() => props.history.push({
          pathname: 'initiate/application',
          state: { isAdminForm: settings?.allow_admin_to_submit_driver_application }
        })}
        translationID="adp.Initieate"
        defaultText="Initiate Application"
      />
      )}
    </SectionHeader>
    {profile?.permissions?.driver_permit?.includes('view_driverpermit')
    ?<>
    <div style={{ display: 'flex' }} className={styles.toolbar}>
      <div className={styles.counter}>
        <FormattedMessage id="adp.list.open" defaultMessage={`Applications (${logsCount ?? 0})`} />
      </div>
        <Filter
        editColumns="AdpColumns"
        handleActionPopup={handleActionPopup}
        actionPopup={state.actionPopup}
        showAction
        columnData={columnData}
        filterCategories={filterCategories}
        handleDropdown={handleFilterDropdown}
        actionPostion
        defaultColumns={allColumns}
        exportToExcel={fetchExcle}
      />
    </div>
      {state.selectedFilters.length !== 0 && (
        <div className={styles.filter}>
          {state?.selectedFilters?.map((category) => {
            if (category?.length !== 0 && category) {
              return (
                <span className={styles.user} key={category}>
                  {category}
                  <span onKeyPress={() => handleRemoveFilterFunction(category)} tabIndex={0} role="button"
                    onClick={() => handleRemoveFilterFunction(category)} className={styles.btnRemove}
                  />
                </span>);
            } return null;
          })}
        </div>)}
    <div className={styles.container}>
      <div className={styles.info} style={{ display: 'block' }}>
        <Summary tags={handleTags(tags)} data={summary} handleStatusFilter={handleStatusFilter} enable_initial_review={enable_initial_review} />
      </div>
    </div>
    <div style={{ marginTop: '2vw' }}>
      <Table tableHeadders={tableKeys} logs={logs} handelDelete={handelDelete}
        route="/adp" handelReprint={handelReprint} {...props}
        enable_initial_review={enable_initial_review || false}
        driverpermit settings={settings}
        sortKey={sortKey}// send false to hide sortKey
        setSortKey={handleSort}// send false to hide sort function
      />
      {logsCount !== 0 && (
      <div className={styles.paginatorContainer}>
        <Paginator
          page={1}
          totalRecords={logsCount}
          pageLimit={20}
          pageNeighbours={1}
          onPageChanged={(pageNo) => { changePage(pageNo); }}
        />
      </div>
      )}
    </div>
    {state.filterPopup && (
      <Transition in={state.filterPopup} timeout={200} unmountOnExit>
        <FilterForm
          transition={slideStyles}
          update={handelUpdateFilters}
          cancel={handleFilterDropdown}
          selectedFilters={state.selectedFilters}
          filter_Categories={filterCategories}
          filter_Object={filterObject}
          filterPostion
        />
      </Transition>
    )}
     </>
   : <Forbidden />
  }
         </>;
};

export default Logs;
